export const PROPERTY_CARD_DETAIL_OFFER_INFO_CONTENT = {
    AVAILABLE_PROPERTIES: (propertiesCount: number) => `W tej inwestycji mamy jeszcze ${propertiesCount} dostępnych mieszkań`,
    FACILITIES_LABEL: "Udogodnienia",
    HEATING_LABEL: "Rodzaj ogrzewania",
    INFO_FROM_VENDOR: "Informacja u dewelopera",
    MORE_INFO_BUTTON: "więcej o inwestycji",
    NO_PARKING_PLACES: "Nie przewidziano miejsc postojowych",
    NOT_PLANNED: "Nie przewidziano",
    PARKING_PLACES_INTRO: "W inwestycji przewidziano:",
    PARKING_PLACES_LABEL: "Miejsca postojowe:",
    PARKING_PRICE_PREFIX: " w cenie ",
    PARKING_QUANTITY_FORMS: ["miejsce", "miejsca", "miejsc"],
    ROOM_HEIGHT_LABEL: "Wysokość pomieszczeń",
    SEE_ALL_BUTTON: "Zobacz wszystkie",
    STANDARD_LABEL: "Standard wykończenia",
    STORAGE_HAS: "Posiada",
    STORAGE_LABEL: "Komórki lokatorskie",
    STORAGE_PRICE_PREFIX: " Komórki lokatorskie w cenie ",
    TITLE: "Inwestycja",
    TRACKING: {
        MORE_INFO: "więcej o inwestycji",
        SEE_ALL: "Zobacz wszystkie"
    }
} as const;
export const PROPERTY_CARD_DETAIL_OFFER_INFO_CONTENT = {
    AVAILABLE_PROPERTIES: (propertiesCount: number) => `W tej inwestycji mamy jeszcze ${propertiesCount} dostępnych mieszkań`,
    FACILITIES_LABEL: "Udogodnienia",
    HEATING_LABEL: "Rodzaj ogrzewania",
    INFO_FROM_VENDOR: "Informacja u dewelopera",
    MORE_INFO_BUTTON: "więcej o inwestycji",
    NO_PARKING_PLACES: "Nie przewidziano miejsc postojowych",
    NOT_PLANNED: "Nie przewidziano",
    PARKING_PLACES_INTRO: "W inwestycji przewidziano:",
    PARKING_PLACES_LABEL: "Miejsca postojowe:",
    PARKING_PRICE_PREFIX: " w cenie ",
    PARKING_QUANTITY_FORMS: ["miejsce", "miejsca", "miejsc"],
    ROOM_HEIGHT_LABEL: "Wysokość pomieszczeń",
    SEE_ALL_BUTTON: "Zobacz wszystkie",
    STANDARD_LABEL: "Standard wykończenia",
    STORAGE_HAS: "Posiada",
    STORAGE_LABEL: "Komórki lokatorskie",
    STORAGE_PRICE_PREFIX: " Komórki lokatorskie w cenie ",
    TITLE: "Inwestycja",
    TRACKING: {
        MORE_INFO: "więcej o inwestycji",
        SEE_ALL: "Zobacz wszystkie"
    }
} as const;
